<div [class]="'hint ' + type">
  <img [src]="'assets/icons/input-hint-' + type + '.svg'" alt="input hint" />
  <p>{{ message }}</p>
</div>
